import Clarity from '@microsoft/clarity';
import { captureErrorInApm } from '../../apm/utils/captureErrorInApm.util';
import { ClarityEvents } from '../types/clarityEvents.types';

export const captureEvent = (eventName: ClarityEvents | string) => {
  if (window.clarity) {
    try {
      Clarity.event(eventName);
    } catch (error: any) {
      captureErrorInApm.clarityError(error);

      console.error(`[withEvent] erro ao disparar o evento ${eventName}:`, error);
    }
  } else {
    console.warn(`[withEvent] clarity não está disponível. evento ${eventName} não foi capturado.`);
  }
};

export const captureEventWithName = (eventName: ClarityEvents, name: string) =>
  captureEvent(`${eventName} ${name}`);

export const withEvent =
  <Args extends unknown[]>(eventName: ClarityEvents | string, fn: (...args: Args) => unknown) =>
  (...params: Args): unknown => {
    captureEvent(eventName);

    return fn(...params);
  };
